var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('Badge',{staticClass:"upgrade-subscription-badge",attrs:{"type":"primary","light":true,"text":_vm.$t('subscription.upgrade')}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }